export const ACTION = {
  RequestTextCollection: 'SHELL:REQUEST_TEXTCOLLECTION',
  ReceiveTextCollection: 'SHELL:RECEIVE_TEXTCOLLECTION'
};

export class RequestTextCollection {
  public type: string = ACTION.RequestTextCollection;
  public path: string;
  public language: number;

  constructor(path: string, language: number) {

    this.path = path;
    this.language = language;
  }
}

export class ReceiveTextCollection {
  public type: string = ACTION.ReceiveTextCollection;
  public texts: any;
  public path: string;
  public language: number;

  constructor(path: string, language: number, texts: any) {

    this.path = path;
    this.language = language;
    this.texts = texts;
  }
}
